import React from 'react';
import Components from '../index';

require('./PageFilter.scss');

const PageFilter = ({
	pages = [],
	filters = [],
	title,
	sidebar,
	perPage = 6,
	linkLabel = 'Learn More',
	emptyMessage = "We couldn't find any matching pages",
	showFilters,
}) => {
	const [activeFilter, setActiveFilter] = React.useState();
	const [sortedPages, setSortedPages] = React.useState([]);
	const [filteredPages, setFilteredPages] = React.useState([]);

	React.useEffect(() => {
		setSortedPages(pages.sort((a, b) => a.title.localeCompare(b.title)));
	}, [pages]);

	React.useEffect(() => {
		let filtered = activeFilter
			? sortedPages.filter((p) => p.tagIds.find((id) => id === activeFilter.id))
			: sortedPages;

		setFilteredPages(filtered);
	}, [activeFilter, sortedPages]);

	const handleSetFilter = (filter) => setActiveFilter(filter);

	const Page = ({ externalUrl, url, image, title }) => {
		return (
			<div className={`card page`}>
				{image && (
					<div className='page__image'>
						<a href={externalUrl && externalUrl.length ? externalUrl : url}>
							<img src={image} alt={title} />
						</a>
					</div>
				)}
				<div className='page__content'>
					{title && (
						<h4 className='page__title'>
							<a href={externalUrl && externalUrl.length ? externalUrl : url}>{title}</a>
						</h4>
					)}
				</div>
			</div>
		);
	};

	return (
		<div className='cmp-pageFilter'>
			<Components.FilterItems
				title={title}
				emptyMessage={emptyMessage}
				filters={filters}
				showFilters={showFilters}
				sidebar={sidebar}
				onFilter={handleSetFilter}
				activeFilter={activeFilter}
				items={filteredPages}
				itemComponent={(page, i) => <Page key={`page-${i}`} {...page} />}
				perPage={perPage}
			/>
		</div>
	);
};

export default PageFilter;
